var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgCopyOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4485_46944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 8.33332C6.66675 7.8913 6.84234 7.46737 7.1549 7.15481C7.46746 6.84225 7.89139 6.66666 8.33341 6.66666H15.0001C15.4421 6.66666 15.866 6.84225 16.1786 7.15481C16.4912 7.46737 16.6667 7.8913 16.6667 8.33332V15C16.6667 15.442 16.4912 15.8659 16.1786 16.1785C15.866 16.4911 15.4421 16.6667 15.0001 16.6667H8.33341C7.89139 16.6667 7.46746 16.4911 7.1549 16.1785C6.84234 15.8659 6.66675 15.442 6.66675 15V8.33332Z",
    stroke: "#858C94",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66668V5.00001C13.3333 4.55798 13.1577 4.13406 12.8451 3.8215C12.5325 3.50894 12.1086 3.33334 11.6666 3.33334H4.99992C4.55789 3.33334 4.13397 3.50894 3.82141 3.8215C3.50885 4.13406 3.33325 4.55798 3.33325 5.00001V11.6667C3.33325 12.1087 3.50885 12.5326 3.82141 12.8452C4.13397 13.1577 4.55789 13.3333 4.99992 13.3333H6.66659",
    stroke: "#858C94",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4485_46944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgCopyOutline);
export default __webpack_public_path__ + "static/media/svg_copy_outline.25d323d0419f09073405b168ac600fae.svg";
export { ForwardRef as ReactComponent };